export const REDUX_SET_SUBSCRIPTION_PLAN = "REDUX_SET_SUBSCRIPTION_PLAN";

export function setSubscriptionPlan(subscription) {
  return {
    type: REDUX_SET_SUBSCRIPTION_PLAN,
    subscription: subscription,
  };
}
